export const styles = {
  sectionTitle: "font-barlow-semibold text-4xl md:text-5xl lg:text-6xl",
  container: "max-w-7xl mx-auto px-4",
  overlay: "absolute inset-0",
  button: "bg-primary hover:bg-primary-dark transition-all duration-300",
};
